/* Norveno: scroll reveal + count-up. Elements with [data-rv] fade up when they enter the screen. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el){
    if (el.dataset.counted) return; el.dataset.counted = '1';
    var end = parseFloat(el.getAttribute('data-count')) || 0, dur = 1200, t0 = null;
    if (reduce || end === 0) { el.textContent = el.getAttribute('data-count'); return; }
    function step(t){ if(!t0) t0 = t; var p = Math.min(1,(t-t0)/dur); p = 1 - Math.pow(1-p,3); el.textContent = Math.round(end*p).toLocaleString('en-US'); if(p<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function show(el){ el.classList.add('rv-in'); el.querySelectorAll('[data-count]').forEach(countUp); if (el.hasAttribute('data-count')) countUp(el); }
  function init(){
    var els = [].slice.call(document.querySelectorAll('[data-rv]:not(.rv-in)'));
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(show); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function(el){ io.observe(el); });
  }
  if (window.__nvReveal) { init(); return; }
  window.__nvReveal = true;
  /* any [data-lf-to-offer] / [data-lf-buy] button buys the selected bundle (presses the main Add to cart, which goes straight to checkout) */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-lf-to-offer],[data-lf-buy]'); if (!b) return;
    var atc = document.querySelector('button[id^="ProductSubmitButton-"]');
    e.preventDefault(); e.stopImmediatePropagation();
    if (atc && !atc.disabled) { b.classList.add('loading'); b.setAttribute('aria-busy','true'); atc.click(); setTimeout(function(){ b.classList.remove('loading'); b.removeAttribute('aria-busy'); }, 6000); return; }
    var o = document.querySelector('[id^="lfOffer-"]'); if (o) o.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
